import getCities from '../../api/resources/getCities';
import SelectWithFetch from './SelectWithFetch';

const SelectCity = (props) => {
  return <SelectWithFetch fetch={getCities} {...props} />;
};

export default SelectCity;
